<template>
  <v-chip color="grey lighten-3" close @click:close="toggleFilter">
    <strong>{{ enquiryStatus.name }}</strong>
  </v-chip>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'enquiry-filter-chips',
  props: ['enquiryStatusId'],
  computed: {
    ...mapGetters(['CustomerPageFilters', 'EnquiryStatuses']),
    enquiryStatus: function() {
      return _.find(this.EnquiryStatuses, ['id', this.enquiryStatusId]);
    }
  },
  methods: {
    ...mapActions(['removeEnquiryStatusFilter', 'getCustomerPage']),
    getPage: _.debounce(function() {
      this.getCustomerPage(false)
        .then(() => {})
        .catch(error => {
          console.log(error);
        });
    }, 250),
    toggleFilter() {
      this.removeEnquiryStatusFilter(this.enquiryStatus).then(() => {
        this.getPage();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
div.input-group {
  padding-top: 0;
}
::v-deep .input-group__details {
  display: none;
}
</style>
